import { render, staticRenderFns } from "./rating-primary.vue?vue&type=template&id=26db8bcc&scoped=true&"
import script from "./rating-primary.vue?vue&type=script&lang=js&"
export * from "./rating-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26db8bcc",
  null
  
)

export default component.exports